export const CATEGORY_CREATE_REQUEST = "CATEGORY_CREATE_REQUEST"
export const CATEGORY_DELETE_REQUEST = "CATEGORY_DELETE_REQUEST"
export const CATEGORY_UPDATE_REQUEST = "CATEGORY_UPDATE_REQUEST"
export const CATEGORY_DETAILS_REQUEST = "CATEGORY_DETAILS_REQUEST"
export const GET_CATEGORIES_REQUEST = "GET_CATEGORIES_REQUEST"


